const MainRedirectToNewSite = () => {
  const currentPath = window.location.pathname.split("/");
  window.location.href = `https://schools.snap.app/${currentPath[1]}`;

  return null;
};

export default MainRedirectToNewSite;
